  document.addEventListener('DOMContentLoaded', function () {
      // Funktion, um die Klasse 'border' basierend auf dem Status der Radiobuttons zu aktualisieren
      function updateBorderClass() {
          const activeTab = document.querySelector('input[name="tabs"]:checked');

          // Vorschau-Bild und Schrift-Item Klassen aktualisieren
          const svgItem = document.querySelector('.preview_image-svg');
          const fontItem = document.querySelector('.font_item');

          if (svgItem) {
              if (activeTab && activeTab.getAttribute('border') === 'svg_item') {
                  svgItem.classList.add('border');
              } else {
                  svgItem.classList.remove('border');
              }
          }

          if (fontItem) {
              if (activeTab && activeTab.getAttribute('border') === 'font_item') {
                  fontItem.classList.add('border');
              } else {
                  fontItem.classList.remove('border');
              }
          }
      }

      // Observer für dynamisches Hinzufügen/Entfernen von Radiobuttons
      const observer = new MutationObserver(() => {
          // Event Listener an alle aktuellen Radiobuttons anfügen
          document.querySelectorAll('input[name="tabs"]').forEach(tab => {
              if (!tab.dataset.listenerAdded) {
                  tab.addEventListener('change', updateBorderClass);
                  tab.dataset.listenerAdded = true; // Markiere, dass ein Listener hinzugefügt wurde
              }
          });
      });

      // MutationObserver initialisieren
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });

      // Initialer Check beim Laden der Seite
      updateBorderClass();

      // Event Listener für das Zurücksetzen der Radiobuttons
      document.addEventListener('click', () => {
          const activeTab = document.querySelector('input[name="tabs"]:checked');
          if (!activeTab) {
              const svgItem = document.querySelector('.preview_image-svg');
              const fontItem = document.querySelector('.font_item');

              if (svgItem) svgItem.classList.remove('border');
              if (fontItem) fontItem.classList.remove('border');
          }
      });
  });